import React from 'react';

import { General } from 'icons/untitledui';

import * as Buttons from 'theme/components/Buttons.style';
import * as Styled from 'shiftNotes/styles/NoteCaptureActionCard.style';
import * as Text from 'theme/components/Text.style';

export interface NoteCaptureActionCardProps {
  title: string;
  description?: string;
  onClose?: () => void;
  primaryLabel: string;
  onPrimaryClick: () => void;
  secondaryLabel?: string;
  onSecondaryClick?: () => void;
  inline?: boolean;
}

export default function NoteCaptureActionCard({
  title,
  description,
  onClose,
  primaryLabel,
  onPrimaryClick,
  secondaryLabel,
  onSecondaryClick,
  inline = false,
}: NoteCaptureActionCardProps): JSX.Element {
  return (
    <Styled.Card $inline={inline}>
      {onClose && (
        <Styled.CloseButton onClick={onClose} aria-label="Close">
          <General.XClose />
        </Styled.CloseButton>
      )}
      <Styled.ContentSection>
        <Text.H4>{title}</Text.H4>
        {description && <Styled.Description>{description}</Styled.Description>}
      </Styled.ContentSection>
      <Styled.ButtonSection>
        {secondaryLabel && onSecondaryClick && (
          <Buttons.SecondaryLight
            $size="medium"
            onClick={onSecondaryClick}
            aria-label={secondaryLabel}
            data-testid="note-capture-action-secondary"
            style={{ flex: 1 }}
          >
            {secondaryLabel}
          </Buttons.SecondaryLight>
        )}
        <Buttons.Primary
          $size="medium"
          onClick={onPrimaryClick}
          aria-label={primaryLabel}
          data-testid="note-capture-action-primary"
          style={{ flex: 1 }}
        >
          {primaryLabel}
        </Buttons.Primary>
      </Styled.ButtonSection>
    </Styled.Card>
  );
}
